import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import { DropzoneArea } from 'material-ui-dropzone'
import Image from 'material-ui-image';
import { capitalize } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    imgDiv: {
        margin: '0 auto',
        maxWidth: 600,
        maxHeight: 600
    },
    img: {
        width: '100%',
        height: '100%',
        maxWidth: window.innerWidth - 100,
        maxHeight: window.innerHeight - 100
    }
});

const LogoForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations, handleUpload, edit, imageValue } = props;
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, handleSubmit, dirty, isSubmitting, handleChange, handleBlur } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            {edit ? <>
                                <div className={classes.imgDiv}>
                                    {imageValue === '' || imageValue === undefined ? (
                                        <Typography variant={"subtitle2"}>{translations['image_will_be_displayed'] || 'Image will be displayed here'}</Typography>
                                    ) : (
                                            <Image
                                                src={imageValue ? imageValue : ''}
                                                aspectRatio={(16 / 9)}
                                                disableSpinner
                                            />
                                        )
                                    }
                                </div>
                            </> : null}
                            <div className={classes.img}>
                                <DropzoneArea
                                    filesLimit={1}
                                    maxFileSize={5368709120}
                                    getFileRemovedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                                        ) : `File ${fileName} removed.`
                
                                        return text;
                                    }}
                                    getFileAddedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                                        ) : `File ${fileName} successfully added.`
                
                                        return text;
                                    }}
                                    getFileLimitExceedMessage={(filesLimit) => {
                                        const text = translations ? (
                                            capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                                        ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`
                
                                        return text;
                                    }}
                                    getDropRejectMessage={(rejectedFile) => {
                                        const text = translations ? (
                                            capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                                        ) : `File was rejected.`
                
                                        return text;
                                    }}
                                    dropzoneText={translations['drag_and_drop'] || 'Drag and drop an image file here or click'}
                                    onChange={handleUpload}
                                    acceptedFiles={['image/*']}
                                />
                            </div>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={!(isValid && dirty) || isSubmitting ? loading : !edit ? loading : false}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(LogoForm);